import React from 'react';
import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { fr } from 'date-fns/locale';
import { TextField } from '@mui/material';

const DateTimePicker = ({ 
  value, 
  onChange, 
  label, 
  minDate, 
  maxDate,
  required = false,
  disabled = false,
  error = false,
  helperText = '',
  className = '',
  sx = {}
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
      <MuiDateTimePicker
        label={label}
        value={value}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        required={required}
        format="dd/MM/yyyy HH:mm"
        views={['year', 'month', 'day', 'hours', 'minutes']}
        slotProps={{
          textField: {
            fullWidth: true,
            variant: 'outlined',
            className: `form-control ${className}`,
            error: error,
            helperText: helperText,
            sx: {
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: 'var(--primary-color)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--primary-color)',
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: 'var(--primary-color)',
              },
              ...sx
            }
          },
          actionBar: {
            actions: ['clear', 'accept'],
          },
        }}
        slots={{
          textField: TextField
        }}
      />
    </LocalizationProvider>
  );
};

export default DateTimePicker; 